import { useState } from 'react';
import axios from 'axios';
import { X, Loader2, CheckCircle } from 'lucide-react';
import { Button } from './ui/button';
import { PasswordInput } from './PasswordInput';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const ChangePasswordModal = ({ onClose }) => {
  const [f, setF] = useState({ current: '', next: '', confirm: '' });
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    if (f.next.length < 8) return setError('La nuova password deve avere almeno 8 caratteri');
    if (f.next !== f.confirm) return setError('Le due password nuove non coincidono');
    setBusy(true);
    setError('');
    try {
      await axios.post(`${API}/auth/change-password`, { current_password: f.current, new_password: f.next },
        { headers: { Authorization: `Bearer ${localStorage.getItem('token')}` } });
      setDone(true);
    } catch (err) {
      setError(typeof err.response?.data?.detail === 'string' ? err.response.data.detail : 'Operazione non riuscita');
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4" data-testid="change-password-modal">
      <div className="bg-white rounded-xl p-6 w-full max-w-sm">
        <div className="flex items-center justify-between mb-4">
          <h3 className="font-semibold text-lg text-[#283880]">Cambia password</h3>
          <button onClick={onClose} data-testid="change-password-close"><X className="w-5 h-5" /></button>
        </div>
        {done ? (
          <div className="space-y-4">
            <p className="flex gap-2 text-sm text-green-700 bg-green-50 p-3 rounded-lg" data-testid="change-password-done"><CheckCircle className="w-4 h-4 shrink-0 mt-0.5" />Password aggiornata. Dal prossimo accesso usi la nuova password.</p>
            <Button onClick={onClose} className="w-full bg-[#283880]">Chiudi</Button>
          </div>
        ) : (
          <form onSubmit={submit} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Password attuale</label>
              <PasswordInput value={f.current} onChange={set('current')} required data-testid="change-password-current" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Nuova password (almeno 8 caratteri)</label>
              <PasswordInput value={f.next} onChange={set('next')} required data-testid="change-password-new" />
            </div>
            <div>
              <label className="block text-sm font-medium mb-1">Ripeta la nuova password</label>
              <PasswordInput value={f.confirm} onChange={set('confirm')} required data-testid="change-password-confirm" />
            </div>
            {error && <p className="text-sm text-red-600" data-testid="change-password-error">{error}</p>}
            <Button type="submit" disabled={busy} className="w-full bg-[#283880]" data-testid="change-password-submit">
              {busy && <Loader2 className="w-4 h-4 mr-2 animate-spin" />}Salva nuova password
            </Button>
          </form>
        )}
      </div>
    </div>
  );
};
